import PropTypes from 'prop-types';

export const APPLE_AUTHENTICATION_DATA_PROPTYPES = PropTypes.shape({
    // isEmailHidden: PropTypes.bool.isRequired, // need to decode now
    sourceProvider: PropTypes.string,
    expirationTimestamp: PropTypes.string,
    email: PropTypes.string,
    accessToken: PropTypes.string,
});
